module.exports = __webpack_public_path__ + "static/media/rectangle-dsktp-logged-in.3253ab0e.png";